export default __webpack_public_path__ + "assets/front/scss/classification-browsing.296dfb31b37c59afbd28aba077b1e154.css";